/// <amd-module name="SuiteCommerce.LookBook.Common.InstrumentationHelper"/>
define("SuiteCommerce.LookBook.Common.InstrumentationHelper", ["require", "exports", "SuiteCommerce.LookBook.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.InstrumentationHelper = void 0;
    var QueueNameSuffix = '-LookBook';
    var ExtensionVersion = '1.0.7';
    var ComponentArea = 'SC Look Book';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (environment) {
            Instrumentation_1.default.initialize({
                environment: environment,
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                }
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
